<template lang="pug">
  .navbar-item.has-dropdown.is-hoverable
    .navbar-link
      | Menú
    .navbar-dropdown
      router-link.a.navbar-item(to="/Planificacion" v-show='verPlanificacion')
        i.fas.fa-calendar-alt
        | &nbspPlanificación
      router-link.a.navbar-item(to="/Resumen" v-show='verResumen')
        i.fas.fa-file-alt
        | &nbspResúmen
      router-link.a.navbar-item(to="/Directorio" v-show='verDirectorio')
        i.fas.fa-phone
        | &nbspDirectorio
      router-link.a.navbar-item(to="/Solicitudes" v-show='verSolicitudes')
        i.fas.fa-phone
        | &nbspSolicitudes
      router-link.a.navbar-item(to="/Soporte" v-show='verSoporte')
        i.fas.fa-laptop-medical
        | &nbspTickets
      router-link.a.navbar-item(to="/Documentacion" v-show='verDocumentacion')
        i.fas.fa-file-code
        | &nbspDocumentación
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'MenuDrop',
    data() {
      return {
        verSolicitudes: false,
        verResumen: false,
        verPlanificacion: false,
        verDirectorio: false,
        verDocumentacion: false,
        verSoporte: false,
      }
    },
    methods: {
      iniciarComponente () {
        switch (this.userLogin.cargo) {
            case '000':
              this.verDirectorio = true
              this.verSoporte = true
              this.verDocumentacion = true
              break
            case '001':
              this.verDirectorio = true
              this.verSoporte = true
              this.verDocumentacion = true
              break
            case '002':
              this.verDirectorio = true
              this.verSoporte = true
              this.verDocumentacion = true
              break
            case '210':
              this.verDirectorio = true
              this.verSoporte = true
              this.verDocumentacion = true
              break
            case '2100':
              this.verDirectorio = true
              this.verSoporte = true
              this.verDocumentacion = true
              break
            case '003':
              this.verDirectorio = true
              this.verSoporte = true
              this.verDocumentacion = true
              break
            case '330':
              this.verDirectorio = true
              this.verSoporte = true
              this.verDocumentacion = true
              break
            case '321':
              this.verDocumentacion = true
              this.verDirectorio = true
              this.verSoporte = true
              break
            case '331':
              this.verDocumentacion = true
            break
            case '332':
              this.verDocumentacion = true
            break
            case '120':
              this.verDirectorio = true
              this.verDocumentacion = true
              break
            case '160':
              this.verDirectorio = true
              this.verDocumentacion = true
              break
            case '230':
              this.verDocumentacion = true
              break
            case '210':
              this.verDocumentacion = true
              break
            case '240':
              this.verDirectorio = true
              this.verDocumentacion = true
              break
            case '241':
              this.verDirectorio = true
              this.verDocumentacion = true
              break
            case '310':
              this.verDirectorio = true
              this.verDocumentacion = true
              break
            case '323':
              this.verDirectorio = true
              this.verDocumentacion = true
              break
            case '324':
              this.verDirectorio = true
              this.verDocumentacion = true
              break
            case '341':
              this.verDirectorio = true
              this.verDocumentacion = true
              break
            case '342':
              this.verDirectorio = true
              this.verDocumentacion = true
              break
            case '343':
              this.verDirectorio = true
              this.verDocumentacion = true
              break
            case '350':
              this.verDirectorio = true
              this.verDocumentacion = true
              break
            case '250':
              this.verDirectorio = true
              this.verDocumentacion = true
              break
            case '370':
              this.verDirectorio = true
              this.verDocumentacion = true
              break
            case '270':
              this.verDirectorio = true
              this.verDocumentacion = true
              break
            default:
              this.verSolicitudes = false
              this.verResumen = false
              this.verPlanificacion = false
              this.verDirectorio = false
              this.verDocumentacion = false
              this.verSoporte = false
              break
          }
        
      }
    },
    created () {
      this.iniciarComponente()
    },
    computed: {
      ...mapState(['logueado', 'userLogin'])
    }
  }
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/layout/MenuDrop.vue